import type {OrderItem} from './order-item'

export type OrderItemsPage = {
  count: number,
  page: number,
  items: OrderItem[]
}
const buildOrderItemsPage = (
  count: number = 10,
  page: number = 0,
  items: OrderItem[]
): OrderItemsPage => ({
  count,
  page,
  items
})

export {
  buildOrderItemsPage
}



// WEBPACK FOOTER //
// ./src/types/orders-items-page.js